import groq from "groq";

import metaFields from "./metaFields";

const jobPosting = groq`
*[_type == "job" && slug.current == $slug] | order(_updatedAt desc) {
    ${metaFields}
    location,
    "createdAt": _createdAt,
    email,
    role,
    blocks[] {
        ...,
        markDefs[] {
            ...,
            _type == "internalLink" => {
                "type": @->_type,
                "slug": @->slug,
                "handle": @->handle,
            },
        },
    },
}[0]  
  `;

export default jobPosting;
